import _PlayCircle from "@mui/icons-material/PlayCircle";
import React from 'react';
import { Image, ImageEntity } from '@fupa/fupa-uikit';
import { ContentOverlay, DateOverlay, IconContainer, ImageContainer, Title, WhiteTypography, Wrapper } from 'app/components/mediaModule/content/contentStyles';
import { LinkOnComponent } from 'app/components/links/link';
import { desktopContentWidth } from 'app/styles/media';
export default function PlaylistElement(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    withBgColor: true,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "PlaylistElement",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.getLink(),
    rel: "nofollow",
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Video,
    src: data.image,
    ratio: "16:9",
    sizesHint: "(min-width: ".concat(desktopContentWidth, "px) 474px, 50vw"),
    "data-sentry-element": "Image",
    "data-sentry-source-file": "PlaylistElement.tsx"
  })), /*#__PURE__*/React.createElement(DateOverlay, {
    "data-sentry-element": "DateOverlay",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(WhiteTypography, {
    variant: "caption1",
    "data-sentry-element": "WhiteTypography",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, data.formatDateRelative())), /*#__PURE__*/React.createElement(ContentOverlay, {
    "data-sentry-element": "ContentOverlay",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(WhiteTypography, {
    variant: "caption1",
    "data-sentry-element": "WhiteTypography",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, data.competitionName), /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "PlaylistElement.tsx"
  }, /*#__PURE__*/React.createElement(_PlayCircle, {
    sx: {
      fontSize: 'inherit'
    },
    "data-sentry-element": "PlayCircle",
    "data-sentry-source-file": "PlaylistElement.tsx"
  })), data.title))));
}